import { createRouter, createWebHistory } from "vue-router";
import Home from "../pages/Home";
// import Premier from "../pages/Premier";
// import Suite from "../pages/Suite";
import InvoicePrint from "../pages/InvoicePrint";

const routes = [
  {
    path: "/:purlId?",
    name: "Home",
    component: Home,
  },
  // {
  //   path: "/premier/:purlId?",
  //   name: "premier",
  //   component: Premier,
  // },
  // {
  //   path: "/suite/:purlId?",
  //   name: "suite",
  //   component: Suite,
  // },
  {
    path: "/invoice-print/:purlId?",
    name: "InvoicePrint",
    component: InvoicePrint,
  },
];
const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_SUB_FOLDER),
  routes,
});

export default router;
